import React, { useEffect, useState, Suspense, lazy } from 'react';
import type { LightboxProps, PortalSettings } from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

const Lightbox = lazy(() => import('yet-another-react-lightbox'));

type ProductLightboxProps = {
  open: boolean;
  onClose: () => void;
  slides: LightboxProps['slides'];
  index: number;
};

const ProductLightbox: React.FC<ProductLightboxProps> = ({ open, onClose, slides, index }) => {
  const [isClient, setIsClient] = useState(false);
  const [portalTarget, setPortalTarget] = useState<PortalSettings | undefined>(undefined);

  useEffect(() => {
    setIsClient(true);
    setPortalTarget({ container: document.body });
  }, []);

  if (!isClient || !portalTarget) return null;

  return (
    <Suspense fallback={null}>
      <Lightbox
        styles={{
          container: { backgroundColor: 'rgba(0 0 0 / 50%)', backdropFilter: 'blur(2px)' },
          thumbnailsContainer: {
            backgroundColor: '#fff',
            // Thumbnails default to a black background which would show through the
            // transparent border of inactive thumbnails as a dark frame — keep it white.
            '--yarl__thumbnails_thumbnail_background': '#fff',
            '--yarl__thumbnails_thumbnail_active_border_color': '#181918',
          } as React.CSSProperties,
        }}
        open={open}
        close={onClose}
        slides={slides}
        index={index}
        portal={portalTarget}
        plugins={[Thumbnails]}
        thumbnails={{
          width: 80,
          height: 80,
          imageFit: 'cover',
          border: 2,
          borderColor: 'transparent',
          borderRadius: 10,
          vignette: false,
          padding: 0,
        }}
      />
    </Suspense>
  );
};

export default ProductLightbox;
